import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-new-hampshire-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./new-hampshire-state-form.component.html",
  styleUrl: "./new-hampshire-state-form.component.scss",
})
export class NewHampshireStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
